import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import * as global from './config/globals';

// Main Component
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { SidebarRightComponent } from './layout/sidebar-right/sidebar-right.component';
import { TopMenuComponent } from './layout/top-menu/top-menu.component';
import { FooterComponent } from './layout/footer/footer.component';
import { PanelComponent } from './layout/panel/panel.component';
import { FloatSubMenuComponent } from './layout/float-sub-menu/float-sub-menu.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

// Component Module
// import { AgmCoreModule } from '@agm/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TrendModule } from 'ngx-trend';
import { HighlightJsModule } from 'ngx-highlight-js';
import { CountdownModule } from 'ngx-countdown';
import { TagInputModule } from 'ngx-chips';


import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HomePage } from './pages/home/home';
import { LoginComponent } from './login/login.component';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { MatSidenavModule } from '@angular/material/sidenav';

// http modules
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { DialogModule } from './main/dialog/dialog.module';
import { AuthIntercept } from './service/connect-backend.service';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { NvD3Module } from 'ng2-nvd3';
import { CountUpModule } from 'ngx-countup';
import 'nvd3';
import { FlexLayoutModule } from '@angular/flex-layout';
// import { DialogChenalSaleComponent } from './main/word/sale/dialog-chenal-sale/dialog-chenal-sale.component';
// import { ReportStockComponent } from './main/report/report-stock/report-stock.component';

// import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';



const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarRightComponent,
    TopMenuComponent,
    FooterComponent,
    PanelComponent,
    FloatSubMenuComponent,
    HomePage,
    LoginComponent,
    SnackbarComponent,
    // DialogChenalSaleComponent,
    // BillDeptorComponent,
  ],
  imports: [
    AppRoutingModule,
    // AgmCoreModule.forRoot({ apiKey: 'AIzaSyC5gJ5x8Yw7qP_DqvNq3IdZi2WUSiDjskk' }),
    BrowserAnimationsModule,
    BrowserModule,
    CountdownModule,
    FormsModule,
    HighlightJsModule,
    LoadingBarRouterModule,
    MatSortModule,
    MatMomentDateModule,
    // MatSnackBar,
    NvD3Module,
    HttpClientModule,
    MatTableModule,
    NgbModule,
    NgxChartsModule,
    NgxDaterangepickerMd.forRoot(),
    PerfectScrollbarModule,
    ReactiveFormsModule,
    TagInputModule,
    TrendModule,
    TranslateModule.forRoot(),
    MatSidenavModule,
    DialogModule,
    TimepickerModule.forRoot(),
    CountUpModule,
    FlexLayoutModule
    // NgxMatDatetimePickerModule,
    // NgxMatTimepickerModule
  ],
  providers: [Title,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthIntercept,
      multi: true
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private router: Router, private titleService: Title, private route: ActivatedRoute) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        const title = 'Jpos 2021';
        this.titleService.setTitle(title);
      }
    });
  }
}

